import React from 'react';
import GeneralMenu from '@/components/navigation/GeneralMenu';
import RecruitmentOverview from './RecruitmentOverview';
import RecruitmentExperience from './RecruitmentExperience';
import RecruitmentIndustry from './RecruitmentIndustry';
import RecruitmentCity from './RecruitmentCity';
import JobTitleCitySearch from '../JobTitleCitySearch';
import { RECRUITMENT_TREND_ITEMS } from '@/constants/job-title';

const RecruitmentTrend = (props: {
  show: boolean;
  recruitmentData: Record<string, any>;
  experienceData: Record<string, any>;
  industryData: Record<string, any>;
  cityData: Record<string, any>;
}) => {
  const { show, recruitmentData, experienceData, industryData, cityData } =
    props;

  return (
    <div
      className={`relative ${show ? 'max-h-full' : 'max-h-0 overflow-hidden'}`}
    >
      <GeneralMenu menuList={RECRUITMENT_TREND_ITEMS} />
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-semibold shrink-0 mr-4">市场需求</h2>
        <JobTitleCitySearch pageUniqueId={RECRUITMENT_TREND_ITEMS[0].id} />
      </div>
      <RecruitmentOverview
        id={RECRUITMENT_TREND_ITEMS[0].id}
        trendData={recruitmentData['新增岗位'] || {}}
      />
      <RecruitmentExperience
        id={RECRUITMENT_TREND_ITEMS[1].id}
        experienceData={experienceData}
      />
      <RecruitmentIndustry
        id={RECRUITMENT_TREND_ITEMS[2].id}
        industryData={industryData}
      />
      <RecruitmentCity id={RECRUITMENT_TREND_ITEMS[3].id} cityData={cityData} />
    </div>
  );
};

export default RecruitmentTrend;
